import React from "react";

// Responsive <picture> with srcset for the photography library.
// slug e.g. "menu-lamb-dosa" maps to /photography/menu-lamb-dosa-{sm|md|lg}.webp
export const Photo = ({
  slug,
  alt = "",
  ratio,
  className = "",
  imgClassName = "",
  sizes = "100vw",
  priority = false,
  overlay = false,
  caption,
}) => {
  if (!slug) return null;
  const base = `/photography/${slug}`;
  const style = ratio ? { aspectRatio: ratio } : undefined;

  return (
    <figure
      data-testid={`photo-${slug}`}
      className={`relative overflow-hidden bg-ink ${className}`}
      style={style}
    >
      <picture>
        <source
          type="image/webp"
          srcSet={`${base}-sm.webp 600w, ${base}-md.webp 1200w, ${base}-lg.webp 2000w`}
          sizes={sizes}
        />
        <img
          src={`${base}-md.webp`}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding={priority ? "sync" : "async"}
          fetchPriority={priority ? "high" : "auto"}
          className={`absolute inset-0 w-full h-full object-cover ${imgClassName}`}
        />
      </picture>
      {overlay && (
        <div className="absolute inset-0 bg-gradient-to-b from-ink/40 via-ink/10 to-ink/70 pointer-events-none" />
      )}
      {caption && (
        <figcaption className="absolute bottom-3 left-4 right-4 flex justify-between text-bone/85 pointer-events-none">
          <span className="text-xs uppercase tracking-wider2 font-bold">{caption}</span>
          <span className="text-xs uppercase tracking-wider2 font-bold opacity-70">
            Photography
          </span>
        </figcaption>
      )}
    </figure>
  );
};

export default Photo;
